<script>
import {deleteLocation} from "@/api/locations";
import UpdateLocationModal from "@/view/components/locations/UpdateLocationModal.vue";
import moment from "moment";
import DataTableSection from "@/view/components/helper/datatable/datatableSingleFetch.vue";

export default {
  name: "locations-list",
  components: {
    UpdateLocationModal,
    DataTableSection
  },
  data() {
    return {
      search: "",
      singleSelect: false,
      selected: [],
      dialogDelete: false,
      dialogMsg: "Are you sure you want to delete this selected items?",
      error: false,
      editedIndex: -1,
      items: [],
      item: null,
      snackbar: false,
      text: "Loading locations...",
      timeout: 2000,
      loading: true,
      tableDataParam: {
        getters: 'getLocations',
        dispatchFunction: 'getLocations',
        headers: [
          {
            text: "Name",
            align: "left",
            sortable: true,
            value: "name"
          },
          {text: "Street", value: "street"},
          {text: "City", value: "city"},
          {text: "State", value: "state"},
          {text: "Zip", value: "zip"},
          {text: "Country", value: "country"}
        ],
      },
      customRenderers: [
        {
          field: "name",
        },
        {
          field: "action",
        }
      ] 

    };


  },
  computed: {
    searchTrigger() {
      return this.search;
    }
  },
  async mounted() {

  },
  watch: {
    searchTrigger(q) {
        let componentEvent = this.$refs.dataTableComponent
        componentEvent.updateSearchField(q)
    }
  },
  methods: {

    exporItems() {
      if (this.selected.length === 0) {
        alert("Please select at least one item")
      } else {
        let locationItems = [];

        for (let i = 0; i < this.selected.length; i++) {
          let location = this.selected[i];
          locationItems.push({
            id: location.id,
            name: location.name,
            street: location.street,
            city: location.city,
            state: location.state,
            zip: location.zip,
            country: location.country
          });
        }
        let csv = this.$papa.unparse(locationItems);
        this.$papa.download(
            csv,
            `LocationsList-${moment().format("YYYY-MM-DD-HH-mm")}`
        );
      }

    }
    ,
    removeItems() {
      if (this.selected.length === 0) {
        this.error = true;
        this.dialogMsg = "Please select at least one item";
      } else {
        this.dialogMsg = "Are you sure you want to delete this selected items?";
        this.error = false;
      }
      this.dialogDelete = true;
    }
    ,
    closeDelete() {
      this.dialogDelete = false;
    },
    async removeItemsConfirm() {
      this.dialogDelete = false;
      for (let i = 0; i < this.selected.length; i++) {
        let item = this.selected[i];
        let response = await deleteLocation(item.id);
        if (response == 204) {
          this.$bvToast.toast(`Deleted ${item.name}`, {
            title: "Location",
            autoHideDelay: 3000,
            appendToast: false,
            variant: "info"
          });
        }
      }
      this.selected = [];
      setTimeout(() => {
        this.$store.dispatch("getLocations");
      }, 2000);
      this.selected = [];
    },
    showUpdateLocationModal(item) {
      this.item = item;
    },
    syncSelectedItem(selectedCollection) {
      this.selected = selectedCollection
    }
  }
};
</script>

<template>
  <v-card flat>
    <div
        class="btn-toolbar justify-content-between"
        role="toolbar"
        aria-label="Toolbar with button groups"
    >
      <div class="btn-group" role="group" aria-label="First group">
        <v-btn class="mr-4" depressed tile small @click="removeItems()">
          <v-icon left> mdi-delete</v-icon>
          Remove
        </v-btn>
        <v-btn class="mr-4" depressed tile small @click="exporItems()">
          <v-icon left> mdi-file</v-icon>
          Export
        </v-btn>
        <v-btn class="mr-4" depressed tile small v-b-modal.modal-add-location>
          <v-icon left> mdi-plus-box</v-icon>
          Add
        </v-btn>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text" id="btnGroupAddon2">
            <b-icon icon="search"></b-icon>
          </div>
        </div>
        <b-form-input v-model="search" placeholder="Search"></b-form-input>
      </div>
    </div>

    <data-table-section
        :tableData="this.tableDataParam"
        :customRenderers="this.customRenderers"
        :isSelectEnabled="true"
        @datatableSelectedItem="syncSelectedItem"
        ref="dataTableComponent"
      >
      <template v-slot:nameparams="{ item }">
        <v-btn
            text
            color="primary"
            @click="showUpdateLocationModal(item)"
            v-b-modal.modal-update-location
        >
          {{ item.name }}
        </v-btn>
      </template>
    </data-table-section>

    <v-dialog v-model="dialogDelete" max-width="510px">
      <v-card>
        <v-card-title class="headline">{{ dialogMsg }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!error" color="blue darken-1" text @click="closeDelete"
          >Cancel
          </v-btn
          >
          <v-btn
              v-if="!error"
              color="blue darken-1"
              text
              @click="removeItemsConfirm"
          >OK
          </v-btn
          >

          <v-btn v-if="error" color="blue darken-1" text @click="closeDelete"
          >Close
          </v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <update-location-modal :item="item"></update-location-modal>
  </v-card>
</template>
